export default "__VITE_ASSET__aqx$rFwm__"